import React from 'react';
import { Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const SignupSuccess = ({ email }) => (
  <div className="signup-success-area">
    <Typography
      variant="body2"
      style={{ marginBottom: 20, color: 'var(--color-text-secondary)', lineHeight: 1.6 }}
    >
      The account for <strong>{email}</strong> has been created.
    </Typography>
    <div className="mfa-actions">
      <Button
        variant="contained"
        color="primary"
        component={RouterLink}
        to="/"
      >
        Sign in
      </Button>
    </div>
  </div>
);

export default SignupSuccess;
